import React from 'react'
import GeneralDetail from './GeneralDetail'
import PersonsDetail from './PersonsDetail'
import '../../styles/detailstab.scss'
import { leagueInvitationStore } from 'state/league/leagueInvitation'
import InviteOrganization from '../Modals/Detail/InviteOrganization'

const Details: React.FC = () => {
  const { inviteModal } = leagueInvitationStore(store => ({
    inviteModal: store.inviteModal,
  }))
  return (
    <>
      <div className="details_main_container">
        <div className="general_detail">
          <GeneralDetail />
        </div>
        <div className="person_detail">
          <PersonsDetail />
        </div>
      </div>
      {inviteModal && <InviteOrganization />}
    </>
  )
}

export default Details
